import { TDraft, TGetFsmState, TSelectors } from './types';

const createSelectors = <
  TValue extends string,
  TEvent extends string,
  TAction extends string,
  IDraft extends TDraft,
>(
  getSliceState: TGetFsmState<TValue, TEvent, TAction, IDraft>,
): TSelectors<TValue, TEvent, TAction, IDraft> => ({
  getValue: (state: any) => getSliceState(state).currentValue,
  getTransitions: (state: any) => {
    const sliceState = getSliceState(state);

    return sliceState.config[sliceState.currentValue].on;
  },
  getConfig: (state: any) => getSliceState(state).config,
  isBusy: (state: any) => getSliceState(state).isBusy,
  getOnUpdateHandler: (state: any) => getSliceState(state).onUpdate,
  getContext: (state: any) => getSliceState(state).context,
  isInitialized: (state: any) => getSliceState(state).isInitialized,
  getDraft: (state: any) => getSliceState(state).draft,
});

export { createSelectors };
